import { isWebViewMode } from '../utils/webviewBridge';
import type { HistorySecretPlatform, HistorySecretProfile } from './types';

export type HistorySecretPlatformPolicy = {
  platform: HistorySecretPlatform;
  allowedProfiles: HistorySecretProfile[];
  preferredProfile: HistorySecretProfile;
  pqAllowed: boolean;
};

export function getHistorySecretPlatformPolicy(): HistorySecretPlatformPolicy {
  const platform: HistorySecretPlatform = isWebViewMode ? 'native' : 'browser';
  if (platform === 'native') {
    return {
      platform,
      allowedProfiles: ['classic', 'pq'],
      preferredProfile: 'classic',
      pqAllowed: true
    };
  }

  return {
    platform,
    allowedProfiles: ['classic'],
    preferredProfile: 'classic',
    pqAllowed: false
  };
}

export function isHistorySecretProfileAllowed(profile: HistorySecretProfile): boolean {
  return getHistorySecretPlatformPolicy().allowedProfiles.includes(profile);
}
